
import React, { useEffect, useState } from 'react';
import { List, NavBar } from 'antd-mobile'

import { 
    BodyView,
    ListView
} from "../factory/ViewUtil";
import { CellStateView } from '../factory/CellViews';
import { FeedbackReplyList } from '../../NetworkFactory';
import { FullURL, ToDate1 } from '../factory/FactoryUtil';


const ItemView = React.memo(({item, onPreview}) => {
    const imgsrc = item.img
    const type = item.type || 0
    return (
        <List.Item  arrowIcon={false} className='cellCardBorder'>
            <div style={{color : type === 1 ? '#6094FF' : '#000'}}>{item.message}</div>
            <div style={{margin : '10px 0', fontSize : '14px'}}>{ToDate1(item.creationDate)}</div>
            <div>
                {
                    imgsrc === undefined ? '' : <img alt='' onClick={onPreview} width={100} height={100} src={FullURL(imgsrc)} style={{objectFit : 'contain', background : '#eee', marginTop : '10px', borderRadius : '8px'}}/>
                }
            </div>
        </List.Item>
    )
});

const FeedbackListController = ({gohome, goback, data, navpush}) => {

    const onPreview = (event, item) => {
        event.stopPropagation();
        navpush('/feedback/preview', false, item)
    }

    const id = data.id || -1
    const [stateCode, setStateCode] = useState(3);
    const [dataSource, setDataSource] = useState([]);
    const requestData = () => {
        FeedbackReplyList(id).then(response => {
            const data = response.data || []
            setStateCode(data.length >0 ? -1 : 1)
            setDataSource(data)
        }).catch(() => {
            setStateCode(1)
        })
    };

    useEffect(() => {
        if(id === -1) {
            gohome()
        }
        else {
            requestData() 
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback} right={
                    <div>
                        <div
                            onClick={()=> {navpush('/feedback/reply', false, {id : id})}}
                            style={{
                                width : 'auto', 
                                float : 'right', 
                                padding : '6px 12px',
                                fontSize : '15px'
                            }}
                        >Reply</div>
                    </div>
                    }>Reply List</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <CellStateView stateType={stateCode} onRefresh={()=>{requestData()}}/> 
                    {
                        dataSource.map((item, index) => (
                            <ItemView 
                                item={item}
                                onPreview={(event)=>{onPreview(event,item)}} 
                                key={index}
                            />
                        ))
                    }
                </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(FeedbackListController)